<div class="sm-flex sm-items-center sm-justify-center">
  <ng-content></ng-content>
  <div class="shadow"></div>
  <div class="background sm-flex">
    <div class="sidebar"></div>
    <div class="content-screen"><div class="navbar"></div></div>
    <div class="sidebar-container"></div>
  </div>
</div>
